import { Component } from '@angular/core';
import {
  CategoryGridItem,
  CategoryGridStoreService
} from '../category-grid-store.service';
import { tap } from 'rxjs/operators';
import * as testIds from '../../testIds';
import { MatIcon } from '@angular/material/icon';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { TestIdDirective } from '../../../directives/test-id.directive';

@Component({
  selector: 'app-grid-breadcrumb',
  templateUrl: './grid-breadcrumb.component.html',
  standalone: true,
  imports: [TestIdDirective, NgIf, MatIcon, NgFor, AsyncPipe]
})
export class GridBreadcrumbComponent {
  testIds = testIds;
  breadcrumbs$ = this.store.breadcrumb$.pipe(
    tap((breadcrumb) => (this.atTopLevel = breadcrumb.length === 0))
  );

  atTopLevel = true;

  constructor(private store: CategoryGridStoreService) {}

  breadcrumbSelected(breadcrumb: CategoryGridItem | null) {
    this.store.jumpToBreadcrumb(breadcrumb);
  }
}
